export const LENSES = [
  { 
    label: 'Strategist', 
   
    requiredPlan: 'free',
    description: "Your personal strategist that delivers structured, boardroom-ready answers with clear analysis, risks, and next moves."
  },
  { 
    label: 'Adaptive Strategist',
 
    requiredPlan: 'professional',
    description: "Adjusts to you. Quick and direct when you need it, or more structured if your ask requires it. Built for conversation, clarifications, and follow-ups — without the rigidity of full strategy mode."
  },
  { 
    label: 'Innovation Catalyst', 

    requiredPlan: 'elite',
    description: "Unlocks bold, non-obvious ideas by using looser rules and more imaginative framing."
  },
 // { 
 //   label: 'Agentic Strategist', 

//    requiredPlan: 'elite',
  //  description: "Focuses on deconstructing problems to find the fundamental reasons behind them. Asks 'why' repeatedly."
//  },
 // { 
  
 //label: 'Market Shake-Up', 
   
  //  requiredPlan: 'elite',
  //  description: "Simulates an aggressive, disruptive mindset to challenge incumbents and find market-breaking angles."
 // },
//  { 
  //  label: 'Strategic Alternatives', 
  
  //  requiredPlan: 'elite',
   // description: "Explores multiple alternative strategies, surfacing unconventional opportunities and the conditions under which they make sense."
 // },
 // { 
 //   label: 'Reality Check', 
   
  //  requiredPlan: 'elite',
   // description: "Acts as a pragmatic, skeptical advisor to pressure-test assumptions and identify potential flaws."
 // },
  { 
    label: 'Risk Horizon Scan', 
  
    requiredPlan: 'elite',
    description: "Scans the near and distant future for potential threats, challenges, and 'black swan' events."
  },
];